import { Box, Typography } from '@mui/material'

const OrderNotSelected = () => {
  return (
    <Box p={2}>
      <Typography style={{ fontWeight: 'bold' }}>
        Please select an order to see the details.
      </Typography>
    </Box>
  )
}

export default OrderNotSelected
